export default "__VITE_ASSET__BTr6IHc1__"